export const STAGE_WIDTH = 550;
export const STAGE_HEIGHT = 400;
export const FRAME_RATE = 31;
